export default function getAvatarColor(primaryLetter: string) {
  const colors = [
    '#E40D39',
    '#FD7D23',
    '#15984A',
    '#FDBD36',
    '#199ED8',
    '#073DA3',
    '#9A3296',
    '#E3289A',
  ];

  if (['A'].includes(primaryLetter)) return colors[0];
  if (['B', 'C', 'D', 'E'].includes(primaryLetter)) return colors[1];
  if (['F', 'G', 'H', 'I'].includes(primaryLetter)) return colors[2];
  if (['J', 'K', 'L'].includes(primaryLetter)) return colors[3];
  if (['M', 'N', 'O'].includes(primaryLetter)) return colors[4];
  if (['P', 'Q', 'R'].includes(primaryLetter)) return colors[5];
  if (['S', 'T', 'U', 'V'].includes(primaryLetter)) return colors[6];
  if (['W', 'X', 'Y', 'Z'].includes(primaryLetter)) return colors[7];

  return colors[0];
}

export function getStatusColor(status: string) {
  if (status === 'Conectado') {
    return '#008A00';
  }
  return '#666666';
}
